export const INVALID_SEAT = 100017;